// extracted by mini-css-extract-plugin
export default {"Label":"qdPv9c9GV9kOXospJQgi","Inherit":"u2BJVh0QZSXl0q88bOsc"};